import RESTSerializer from '@ember-data/serializer/rest';
import { underscore } from '@ember/string';
export default class BaseChannelSerializer extends RESTSerializer {
  keyForAttribute(attr) {
    return underscore(attr);
  }
  normalizeResponse(store, primaryModelClass, payload, id, requestType) {
    const normalizedPayload = payload;
    if (normalizedPayload.cursor || normalizedPayload.cursor === '') {
      normalizedPayload.meta = Object.assign(normalizedPayload.meta || {}, {
        cursor: normalizedPayload.cursor
      });
      delete normalizedPayload.cursor;
    }
    if (normalizedPayload.next_cursor || normalizedPayload.next_cursor === '') {
      normalizedPayload.meta = Object.assign(normalizedPayload.meta || {}, {
        next_cursor: normalizedPayload.next_cursor
      });
      delete normalizedPayload.next_cursor;
    }
    if (normalizedPayload.prev_cursor || normalizedPayload.prev_cursor === '') {
      normalizedPayload.meta = Object.assign(normalizedPayload.meta || {}, {
        prev_cursor: normalizedPayload.prev_cursor
      });
      delete normalizedPayload.prev_cursor;
    }
    return super.normalizeResponse(store, primaryModelClass, normalizedPayload, id, requestType);
  }
}